import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-previews"
export default class extends Controller {
  static targets = ["input", "preview"]

  declare inputTarget: HTMLInputElement
  declare previewTarget: HTMLImageElement

  preview() {
    const input = this.inputTarget
    const preview = this.previewTarget
    const file = input.files[0]

    const reader = new FileReader()

    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        preview.src = reader.result
      }
    }

    const allowedFileTypes = ["image/png", "image/jpeg"]
    if (!!file && allowedFileTypes.includes(file.type)) {
      reader.readAsDataURL(file)
      preview.classList.remove("d-none")
    } else {
      preview.classList.add("d-none")
    }
  }
}
